import React from 'react';
import { Box, Grid } from '@mui/material';
import AccountSettings from './components/AccountSettings.tsx';
import NotificationSettings from './components/NotificationSettings.tsx';
import SecuritySettings from './components/SecuritySettings.tsx';
import PreferenceSettings from './components/PreferenceSettings.tsx';
import { useSettings } from './hooks/useSettings.ts';
import GradientText from '../../components/common/GradientText.tsx';
import HolographicBackground from '../../components/common/HolographicBackground.tsx';
import HolographicContainer from '../../components/common/HolographicContainer.tsx';

const Settings: React.FC = () => {
  const { settings, updateSettings, isLoading, error } = useSettings();

  const handleUpdate = async (type: string, data: any) => {
    await updateSettings(type, data);
  };

  if (isLoading) {
    return (
      <HolographicBackground>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
        }}>
          <GradientText variant="h5" gradient="primary">Loading...</GradientText>
        </Box>
      </HolographicBackground>
    );
  }

  if (error) {
    return (
      <HolographicBackground>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
        }}>
          <GradientText variant="h5" gradient="secondary" sx={{ color: '#ff6b6b' }}>
            Error loading settings
          </GradientText>
        </Box>
      </HolographicBackground>
    );
  }

  return (
    <HolographicBackground>
      <Box sx={{ p: 4 }}>
        <GradientText variant="h4" gradient="primary" sx={{ mb: 4 }}>
          Settings
        </GradientText>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <HolographicContainer sx={{ height: '100%' }}>
              <AccountSettings 
                settings={settings.account} 
                onUpdate={handleUpdate} 
              />
            </HolographicContainer>
          </Grid>

          <Grid item xs={12} md={6}>
            <HolographicContainer sx={{ height: '100%' }}>
              <SecuritySettings 
                settings={settings.security} 
                onUpdate={handleUpdate} 
              />
            </HolographicContainer>
          </Grid>

          <Grid item xs={12} md={6}>
            <HolographicContainer sx={{ height: '100%' }}>
              <NotificationSettings 
                settings={settings.notifications} 
                onUpdate={handleUpdate} 
              />
            </HolographicContainer>
          </Grid>

          <Grid item xs={12} md={6}>
            <HolographicContainer sx={{ height: '100%' }}>
              <PreferenceSettings 
                settings={settings.preferences} 
                onUpdate={handleUpdate} 
              />
            </HolographicContainer>
          </Grid>
        </Grid>
      </Box>
    </HolographicBackground>
  );
};

export default Settings; 